import React from 'react';
import { HeartIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-[#0f172a] to-[#1e293b]" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-135">
        <div className="bg-gradient-to-br from-amber-900/20 to-teal-900/20 p-8 md:p-12 rounded-3xl border border-amber-500/20 text-center relative overflow-hidden" data-id="element-136">
          <HeartIcon className="absolute -top-10 -right-10 w-48 h-48 text-amber-500/5 rotate-12" data-id="element-137" />

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 relative z-10" data-id="element-138">
            Lo Que Cambia en 7 Días
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed relative z-10" data-id="element-139">
            <p data-id="element-140">
              Las discusiones por "se te olvidó de nuevo" se reducen
              drásticamente porque la responsabilidad de recordar se traslada
              del cerebro al soporte visual de la pared.
            </p>
            <p className="font-semibold text-amber-400 text-xl md:text-2xl pt-4" data-id="element-141">
              El resentimiento disminuye cuando el esfuerzo invisible de ambos
              se vuelve, por fin, visible.
            </p>
          </div>
        </div>
      </div>
    </section>;
}